import React from "react";
import Render from "@gqlapp/theme";
import template from "./view.html.twig";
import { sharedPartials } from "@modules/layout/partials";
import VideoEmbed from "@lib/components/VideoEmbed";
import { safeQuery, fetchMenu, fetchList } from "@lib/content/fetch";
import { cleanPath, toTeasers } from "@lib/content/normalize";
import VIDEO_QUERY from "@modules/video/graphql/VideoQuery.graphql";
import VIDEOS_QUERY from "@modules/video/graphql/VideosQuery.graphql";

const EMPTY = { found: false, title: '', videoUrl: '', media: [], categories: [] };

export default function ViewContainer(props: any){
	const { videoData } = props;
	return <>
		<Render {...{ template, context: { partials: { ...sharedPartials }, VideoEmbed, ...EMPTY, ...(videoData || {}) } }} />
	</>;
}

ViewContainer.getInitialProps = async (ctx: any) => {
	const { apolloClient } = ctx || {};
	const path = cleanPath(ctx?.path);

	try {
		const [data, more, categories] = await Promise.all([
			safeQuery(apolloClient, VIDEO_QUERY, { path }),
			fetchList(apolloClient, VIDEOS_QUERY, { page: 1, pageSize: 6 }),
			fetchMenu(apolloClient, 'video'),
		]);
		const res = data?.res;
		return { videoData: { found: !!res, title: res?.title || ctx?.graphqlRoute?.title || '', videoUrl: res?.video_url || '', media: toTeasers(more.edges), categories } };
	} catch (e) {
		debug(e);
		return { videoData: { ...EMPTY, title: ctx?.graphqlRoute?.title || '' } };
	}
};
